export default "__VITE_ASSET__18699083__"